import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {Router} from "@angular/router"

import { TShirtsFormsService } from './t-shirts-forms.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';


@Component({
  selector: 'app-t-shirts-forms',
  templateUrl: './t-shirts-forms.component.html',
  styleUrls: ['./t-shirts-forms.component.css']
})
export class TShirtsFormsComponent implements OnInit {

  sizes: string[];
  tShritForm: FormGroup;
  teste: any;
  modalRef: BsModalRef;

  constructor(private tShirtsFormsService: TShirtsFormsService,
    private router: Router, private modalService: BsModalService) { 
    this.sizes = [
      "PP",
      "P",
      "M",
      "G",
      "GG"
    ];
    this.tShritForm = new FormGroup({
      name: new FormControl('', Validators.required),
      cpf: new FormControl('', Validators.required),
      cellPhone: new FormControl('', Validators.required),
      size: new FormControl(this.sizes[0], Validators.required),
      payment: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, 
          Validators.email])
    });
  }

  ngOnInit() {
  }

  onSubmit() {
    this.tShirtsFormsService.saveUser(this.tShritForm.value).then(user => {
      if (this.tShritForm.value.payment === "PicPay") {
        this.tShirtsFormsService.requestPayment(user.id, this.tShritForm.value);
      } else {
        this.router.navigate(['/payment-completed', user.id]);
      }
    })
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

}
